import styled from 'styled-components'

const Title = styled.h2`
  font-size: 0.83em;
`
export default Title
